/**
 * Legacy module — preserved as an empty module so existing dependencies
 * (`acme.common.service.posConfig`) keep resolving.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/pos-config/pos-config.service.ts
 *
 * It's registered with AngularJS in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * via downgradeInjectable, so any `$inject = ['PosConfigService']` resolves
 * to the Angular 18 class. The six sub-services are internal to PosConfigService
 * (injected directly as Angular 18 classes) and are NOT downgrade-registered;
 * their legacy module shells stay empty for the module-dependency graph.
 * Wave 3 item #17.
 */
angular.module('acme.common.service.posConfig', [
  'acme.common.service.helpers',
  'acme.common.service.posConfigOptions',
  'acme.common.service.posConfigImages',
  'acme.common.service.posConfigTiles',
  'acme.common.service.posConfigPages',
  'acme.common.service.posConfigNavigation',
  'acme.common.service.posConfigSettings',
]);
